import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { XpoAuthenticationGuard } from '@xpo/ngx-auth';
import { MainComponent } from './main/main.component';

const routes: Routes = [
  {
    path: 'mile-calc',
    component: MainComponent,
    canActivate: [XpoAuthenticationGuard],
  },
  { path: '', redirectTo: 'mile-calc', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
